import {
  Typography,
  Grid,
  Tabs,
  Tab,
  TextField,
  MenuItem,
  Box,
  Button,
  CircularProgress,
} from '@mui/material';
import Page from 'components/page';
import CustomizedTables from 'components/table';
import { a11yProps } from 'components/tabpanel';
import useFourGFetch from 'hooks/useFourGFetch';
import TabPanel from 'components/tabpanel';
import React, { useState } from 'react';
import { states } from 'utils';
import useContactUsMutation from 'hooks/useContactUsMutation';
function FourGPage() {
  const handleChange = (event, newValue) => {
    setValue(newValue);
  };
  const mutateQuery = useContactUsMutation();
  const [value, setValue] = React.useState(0);
  const [error, setError] = React.useState({
    firstName: false,
    lastName: false,
    email: false,
    mobile: false,
    province: false,
  });
  const [formData, setFormData] = useState({ province: 'مازندران' });

  const query = useFourGFetch();

  const formChangeHandler = (e) => {
    const name = e.target.name;
    const value = e.target.value;
    setFormData((prevState) => {
      return {
        ...prevState,
        [name]: value,
      };
    });
    setError((prevState) => {
      return {
        ...prevState,
        [name]: false,
      };
    });
  };
  const formSubmitHandler = () => {
    let formError = false;
    Object.keys(error).forEach((item) => {
      if (!formData[item]) {
        formError = true;
        setError((prevState) => {
          return {
            ...prevState,
            [item]: true,
          };
        });
      }
    });
    if (!formError) {
      console.log('Form', formData);
      mutateQuery.mutate(formData);
      setFormData({ province: 'مازندران' });
    }
  };
  return (
    query.data && (
      <Page title={'اینترنت نسل چهار'}>
        <Grid container>
          <Grid item xs={12}>
            <div className="container">
              <Typography variant="h4" fontWeight={600}>
                {query.data?.data?.attributes?.title}
              </Typography>
              <Typography
                component={'div'}
                sx={{ mt: 4 }}
                variant="body1"
                color={'text.secondary'}
                dangerouslySetInnerHTML={{
                  __html: query.data?.data?.attributes?.description,
                }}></Typography>
            </div>
          </Grid>

          <Grid item xs={12}>
            <div className="container">
              {query.data?.data?.attributes?.sections.data.map(
                (item, index) => {
                  return (
                    <>
                      <Typography
                        key={index}
                        variant="h5"
                        fontWeight={600}
                        sx={{ mb: 4 }}>
                        {item.attributes.title}
                      </Typography>
                      {item.attributes.tabs.data.length > 1 ? (
                        <>
                          <Tabs
                            value={value}
                            onChange={handleChange}
                            textColor="secondary"
                            indicatorColor="secondary"
                            style={{ marginTop: 100 }}
                            aria-label="basic tabs example">
                            {item.attributes.tabs.data.map((item, idx) => {
                              return (
                                <Tab
                                  label={item.attributes.title}
                                  {...a11yProps(idx)}
                                />
                              );
                            })}
                          </Tabs>
                          {item.attributes.tabs.data.map((item, idx) => {
                            return item.attributes.service_tables.data.map(
                              (item, counter) => {
                                return (
                                  <TabPanel value={value} key={idx} index={idx}>
                                    <Typography
                                      id={idx}
                                      sx={{
                                        mt: 1,
                                        mb: 2,
                                        textAlign: 'center',
                                      }}
                                      color={'text.secondary'}>
                                      {item.attributes.title}
                                    </Typography>

                                    <CustomizedTables
                                      rawRows={item.attributes.row}
                                    />
                                    <Typography
                                      component={'div'}
                                      sx={{ mt: 4 }}
                                      variant="body1"
                                      color={'text.secondary'}
                                      style={{
                                        fontFamily: 'IranSans !important',
                                      }}
                                      dangerouslySetInnerHTML={{
                                        __html: item.attributes.body,
                                      }}></Typography>
                                  </TabPanel>
                                );
                              }
                            );
                          })}
                        </>
                      ) : (
                        <div style={{ marginTop: 20 }}>
                          <Typography
                            id={index}
                            sx={{
                              mt: 5,
                              mb: 2,
                              textAlign: 'center',
                            }}
                            color={'text.secondary'}>
                            {
                              item.attributes.tabs.data[0].attributes
                                .service_tables.data[0].attributes.title
                            }
                          </Typography>
                          <CustomizedTables
                            rawRows={
                              item.attributes.tabs.data[0].attributes
                                .service_tables.data[0].attributes.row
                            }
                          />
                        </div>
                      )}
                    </>
                  );
                }
              )}
            </div>
          </Grid>
          <Grid item xs={12} sx={{ my: 5 }}>
            <div className="container">
              <Typography variant="body1" fontWeight={600} sx={{ mb: 3 }}>
                درخواست مشاوره رایگان سرویس 4G
              </Typography>
              <Grid container spacing={2} sx={{ px: 10 }}>
                <Grid item xs={12} md={6}>
                  <TextField
                    label="نام"
                    name={'firstName'}
                    value={formData.firstName || ''}
                    fullWidth
                    error={error.firstName}
                    onChange={formChangeHandler}
                  />
                </Grid>
                <Grid item xs={12} md={6}>
                  <TextField
                    name={'lastName'}
                    value={formData.lastName || ''}
                    label="نام خانوادگی"
                    fullWidth
                    error={error.lastName}
                    onChange={formChangeHandler}
                  />
                </Grid>
                <Grid item xs={12} md={6}>
                  <TextField
                    name={'mobile'}
                    value={formData.mobile || ''}
                    label="شماره تلفن همراه"
                    fullWidth
                    error={error.mobile}
                    onChange={formChangeHandler}
                  />
                </Grid>
                <Grid item xs={12} md={6}>
                  <TextField
                    label="ایمیل"
                    value={formData.email || ''}
                    fullWidth
                    error={error.email}
                    name={'email'}
                    onChange={formChangeHandler}
                  />
                </Grid>
                <Grid item xs={12} md={6}>
                  <TextField
                    label="استان"
                    name={'province'}
                    value={formData.province || ''}
                    fullWidth
                    select
                    error={error.province}
                    onChange={formChangeHandler}>
                    {states.map((item) => item)}
                  </TextField>
                </Grid>
                <Grid item xs={12}>
                  <Box sx={{ display: 'flex', justifyContent: 'end' }}>
                    <Button
                      variant="contained"
                      onClick={formSubmitHandler}
                      disabled={mutateQuery.isLoading}>
                      {mutateQuery.isLoading ? (
                        <CircularProgress
                          size="1.4rem"
                          sx={{ fontSize: '0.5rem' }}
                        />
                      ) : (
                        'ثبت'
                      )}
                    </Button>
                  </Box>
                </Grid>
              </Grid>
            </div>
          </Grid>
        </Grid>
      </Page>
    )
  );
}

export default FourGPage;
